export default "__VITE_ASSET__3121ba55__"